import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { get as _get, map as _map } from "lodash";
import { useDispatch } from "react-redux";

import { downloadExcelFile } from "../../../../helpers/utils";
import { showAlertMessage } from "../../formElements";

import { updateLoadingState } from "../../../../redux/actions/application";
import { exportSearchData } from "../../../../redux/services/dataSearch";

const ExportSearchButton = ({
  source = "",
  selectedAllIds = false,
  selectedIds = [],
  selectedJobSeniority = [],
  selectedIndustry = [],
  selectedRegionCountry = [],
  selectedCompanySize = [],
  selectedRevenue = [],
  selectedDepartment = [],
  uploadedTalContactIds = [],
  savedSearchId = null
}) => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const handleExport = async () => {
    try {
      if (typeof updateLoadingState === "function") { dispatch(updateLoadingState(true)); }

      const hasAnyFilter = [
        selectedIds,
        savedSearchId,
        selectedJobSeniority,
        selectedIndustry,
        selectedRegionCountry,
        selectedCompanySize,
        selectedRevenue,
        selectedDepartment,
        uploadedTalContactIds,
      ].some((arr) => (arr || []).length > 0);

      if (!hasAnyFilter) {
        showAlertMessage(
          intl.formatMessage({ id: "error.select_atleast_one_filter", defaultMessage: "Please select at least one filter." })
        );
        return;
      }

      const payload = {
        source: (source || ""),
        job_seniority: _map(selectedJobSeniority || [], (item) => _get(item, "id", "")),
        country: _map(selectedRegionCountry || [], (item) => _get(item, "id", "")),
        company_size: _map(selectedCompanySize || [], (item) => _get(item, "id", "")),
        revenue: _map(selectedRevenue || [], (item) => _get(item, "id", "")),
        department: _map(selectedDepartment || [], (item) => _get(item, "id", "")),
        selected_contact_ids: (selectedAllIds) ? [] : (selectedIds || []),
        tal_contact_ids: (uploadedTalContactIds || []),
        industry: _map(selectedIndustry || [], (item) => _get(item, "id", "")),
        search_id: (savedSearchId || null)
      };

      const response = await exportSearchData(payload);

      if (_get(response, "flag", false) === true) {
        const isExport = _get(response, "data.is_export", true);

        if (isExport) {
          const downloadFileDetails = _get(response, "data", {});

          const contentType = _get(downloadFileDetails, "contentType", "");
          const contents = _get(downloadFileDetails, "Contents", "");
          const filename = _get(downloadFileDetails, "filename", payload.file_name);

          if ((contentType !== "") && (contents !== "") && (filename !== "")) {
            downloadExcelFile(contentType, contents, filename);
            showAlertMessage(intl.formatMessage({ id: "message.file_generated_successfully", defaultMessage: "File generated successfully." }), "success");
          } else {
            showAlertMessage(intl.formatMessage({ id: "message.file_generation_failed", defaultMessage: "Failed to generate file." }));
          }
        } else {
          showAlertMessage(_get(response, "message", "Export initiated. Export data will be sent via email"), "success");
        }
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while exporting."));
      }
    } catch (err) {
      showAlertMessage(err.message || "Something went wrong while exporting.");
    } finally {
      if (typeof updateLoadingState === "function") { dispatch(updateLoadingState(false)); }
    }
  };

  return (
    <button type="button" className="btn btn-light waves-effect flex-fill text-capitalize" onClick={handleExport}>
      <FormattedMessage id="btn.export" defaultMessage="export" />
    </button>
  );
};

export default ExportSearchButton;
